import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useLocationSettings from '../../../../utils/useLocationSettings';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import FulfilmentLocationSearchForm from '../../../../components/FulfilmentLocationSearchForm';
import FormDrawer from '@afosto/app-components-react/FormDrawer';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import getAddressString from '@afosto/utils/getAddressString';
import translations from './translations';

const LocationSettings = () => {
  const intl = useIntl();
  const [hasPermissions, UnauthorizedComponent] = usePermissions(['lcs:locations:read']);
  const [showEditLocations, setShowEditLocations] = useState(false);
  const { isLoading, locationSettings, saveLocationSettings } = useLocationSettings({
    fetchLocationsEnabled: true,
  });
  const { enqueueSnackbar } = useSnackbar();

  const handleSetLocationSettings = ({ locations }) => {
    saveLocationSettings(locations);
    enqueueSnackbar(intl.formatMessage(translations.feedback.locationSettingsSaved), {
      variant: 'success',
    });
    setShowEditLocations(false);
  };

  if (!hasPermissions()) {
    return (
      <Card>
        <CardHeader
          title={intl.formatMessage(translations.title)}
          titleTypographyProps={{ variant: 'h6' }}
          subheader={intl.formatMessage(translations.subtitle)}
          subheaderTypographyProps={{ variant: 'caption' }}
        />
        <CardContent>
          <UnauthorizedComponent showActions={false} />
        </CardContent>
      </Card>
    );
  }

  return (
    <>
      <Card>
        <CardHeader
          title={intl.formatMessage(translations.title)}
          titleTypographyProps={{ variant: 'h6' }}
          subheader={intl.formatMessage(translations.subtitle)}
          subheaderTypographyProps={{ variant: 'caption' }}
        />
        <LoadingWrapper isLoading={isLoading}>
          <Divider />
          <Box display="flex" p={2} pl={0}>
            <List dense disablePadding style={{ flex: 1 }}>
              <Box pl={2} py={1}>
                <Typography component="div" variant="subtitle2" color="textSecondary">
                  Locaties
                </Typography>
              </Box>
              {(locationSettings ?? []).map(location => (
                <ListItem key={location.name}>
                  <ListItemText
                    primary={location?.name}
                    secondary={location?.address ? getAddressString(location?.address) : '-'}
                  />
                </ListItem>
              ))}
              {!locationSettings?.length && (
                <ListItem>
                  <ListItemText
                    primary={intl.formatMessage(translations.feedback.noLocationSelected)}
                  />
                </ListItem>
              )}
            </List>
            <Box ml={1}>
              <Button onClick={() => setShowEditLocations(true)} variant="outlined">
                <FormattedMessage {...translations.actions.edit} />
              </Button>
            </Box>
          </Box>
        </LoadingWrapper>
      </Card>
      <FormDrawer
        isOpen={showEditLocations}
        title={intl.formatMessage(translations.editDrawer.title)}
        drawerWidth="420px"
        onClose={() => setShowEditLocations(false)}
      >
        <FulfilmentLocationSearchForm
          onCancel={() => setShowEditLocations(false)}
          onSubmit={handleSetLocationSettings}
          locations={locationSettings}
        />
      </FormDrawer>
    </>
  );
};

export default LocationSettings;
